import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
@Component({
  selector: 'app-offers-card',
  templateUrl: './offers-card.component.html',
  styleUrls: ['./offers-card.component.scss']
})
export class OffersCardComponent implements OnInit {

  @Input() merchant: any;
  @Input() authenticated_user: boolean;
  @Input() isMobile: boolean;
  @Output() claimOffer = new EventEmitter<any>();
  @Output() merchantClicked = new EventEmitter<any>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public GlobalConstants: GlobalConstants,
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem('currentUser')) {
      this.authenticated_user = true;
    }
    if(this.merchant && this.merchant.attributes && this.merchant.attributes.offers && this.merchant.attributes.offers.data && this.merchant.attributes.offers.data.length > 1){
      this.sortOffers(this.merchant.attributes.offers.data);
    }
  }
  sortOffers(offers){
      offers.sort(function (a, b) {
        var textA = moment(a.attributes.updated_at);
        var textB = moment(b.attributes.updated_at);
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        return (textA.diff(textB) < 0) ? -1 : (textA.diff(textB) > 0) ? 1 : 0;
    })
  }
  checkKeyExists(json, key) {
    return key in json ? true : false;
  }

  getApplicableTag(applicableOnArr) {
    if (!applicableOnArr || !applicableOnArr.includes('credit')) {
      return `Applicable on Debit Card`;
    }
    if (applicableOnArr.includes('debit') && applicableOnArr.includes('credit')) {
      return `Applicable on Debit Card and Credit Card`;
    }
    if (applicableOnArr.includes('credit')) {
      return `Applicable on Credit Card`;
    }
  }

  emitRedeemOffer(merchant) {
    this.claimOffer.emit();
  }

  clickMerchant(event, merchant, action) {
    this.merchantClicked.emit({merchant, action});
  }
  enableRouterReload(toReload){
    // if(toReload){
    //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //       return false;
    //   }
    //   this.router.onSameUrlNavigation = 'reload';
    // }

  }
}
